module.exports = __webpack_public_path__ + "img/T6-D-rc_22.3aa0007c.png";